export var shadow = {
  color: 'rgb(0 0 0 / 12%)',
  depth: {
    100: "0px 8px",
    200: "0px 12px",
    300: "2px 16px",
    400: "4px 20px",
    500: "8px 24px",
    600: "12px 28px"
  }
};
var base = {
  100: "0 ".concat(shadow.depth[100], " ").concat(shadow.color),
  200: "0 ".concat(shadow.depth[200], " ").concat(shadow.color),
  300: "0 ".concat(shadow.depth[300], " ").concat(shadow.color),
  400: "0 ".concat(shadow.depth[400], " ").concat(shadow.color),
  500: "0 ".concat(shadow.depth[500], " ").concat(shadow.color),
  600: "0 ".concat(shadow.depth[600], " ").concat(shadow.color)
};
export var shadows = {
  100: base[100],
  200: base[200],
  300: base[300],
  400: base[400],
  500: base[500],
  600: base[600],
  card: base[300],
  dropdown: base[400],
  dialog: base[600]
};
export default shadows;